module.exports = __webpack_public_path__ + "static/tab-bottom-curve-c70a591a00b340b017fe1524c3bbb7bc.svg";